import {v4 as uuid} from 'uuid';

import type {
    ChatActivityType,
    ChatActivityMessageParticipants,
    ChatMessage,
} from '../types';

export const appendGroupedParticipants = (
    previousMessage: ChatMessage,
    newMessage: ChatMessage,
): ChatActivityMessageParticipants[] | undefined => {
    if (previousMessage.groupedParticipants?.length) {
        return [
            ...previousMessage.groupedParticipants,
            {
                identity: newMessage.identity,
                displayName: newMessage.displayName,
                timestamp: newMessage.timestamp,
            },
        ];
    }

    return [
        {
            identity: previousMessage.identity,
            displayName: previousMessage.displayName,
            timestamp: previousMessage.timestamp,
        },
        {
            identity: newMessage.identity,
            displayName: newMessage.displayName,
            timestamp: newMessage.timestamp,
        },
    ];
};

export const buildGroupedActivityMessage = (
    activityType: ChatActivityType,
    previousMessage: ChatMessage,
    newMessage: ChatMessage,
): ChatMessage => ({
    ...newMessage,
    activityType,
    displayName: '',
    groupedParticipants: appendGroupedParticipants(previousMessage, newMessage),
});

export const buildRemoveActivityMessage = ({
    meetingId,
    myIdentity,
    member,
    getDisplayName,
}: {
    meetingId: string;
    myIdentity: string;
    member: {identity: string; actor: string}; // FIXME: make it more generic
    getDisplayName: (identity: string) => string;
}): ChatMessage => ({
    id: uuid(),
    topic: meetingId,
    displayName: getDisplayName(member.actor || ''),
    message: ' removed ',
    type: 'activity',
    activityType: 'removed',
    identity: uuid(),
    timestamp: new Date().toLocaleString(),
    removedParticipant: {
        identity: member.identity,
        displayName:
            myIdentity === member.identity
                ? 'You'
                : getDisplayName(member.identity),
    },
});
